<template>
    <div class="kinship-wrapper">
        <div v-if="isShowTitle" class="mb20 fb">{{title}}</div>
        <avue-crud :data="data" :option="option" v-model="form" :table-loading="loading" ref="crud" :before-open="beforeOpen" @error="error"></avue-crud>
    </div>
</template>
<script>
import { orderInitialRecordList } from '@/api/order/index'
export default {
    props: {
        isShowTitle: {
            type: Boolean,
            default: false,
        },
        title: {
            type: String,
            default: '派单记录'
        },
        orderId: {
            type: String,
            default: ''
        },
        isOpt: {
            type: Boolean,
            default: false
        },
        date: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            form: {},
            loading: true,
            page: {
                pageSize: 10,
                currentPage: 1,
                total: 0
            },
            data: [],
            option: {
                size: 'mini',
                border: true,
                align: 'center',
                menuAlign: 'center',
                delBtn: true,
                viewBtn: true,
                addBtn: false,
                cellBtn: false,
                columnBtn: false,
                refreshBtn: false,
                menuBtn: false,
                labelWidth: 100,
                menu: this.isOpt,
                column: [{
                        label: '初始计划单',
                        prop: 'initialPlanNo',
                    },
                    {
                        label: '初始计划单序号',
                        prop: 'orderInitNumber',
                    },
                    {
                        label: "类型",
                        prop: "initPlanType",
                        type: "select",
                        dicUrl: "/api/blade-system/dict-biz/dictionary",
                        dicQuery: {
                            code: "work_type"
                        },
                        formatter: (row, value, label, column) => {
                            return label
                        },
                        props: {
                            label: "dictValue",
                            value: "dictKey"
                        },
                        rules: [{
                            required: true,
                            message: "请选择类型",
                            trigger: "click"
                        }]
                    },
                    {
                        label: '派单时间',
                        prop: 'initPlanTime',
                        type: 'date',
                        valueFormat: "yyyy-MM-dd hh:mm:ss",
                    },
                    {
                        label: '派单人',
                        prop: 'initPlanUserName',
                    },
                    {
                        label: "派单类型",
                        prop: "type",
                        type: "select",
                        dicData: [{
                            label: '新增',
                            value: 0
                        }, {
                            label: '系统退回',
                            value: 1
                        }, {
                            label: '重新派单',
                            value: 2
                        }],
                        rules: [{
                            required: true,
                            message: "请选择类型",
                            trigger: "click"
                        }]
                    },
                ]
            },
            id: ''
        }
    },
    watch: {
        orderId() {
            this.id = this.orderId
            this.onLoad()
        },
        date() {
            this.onLoad()
        }
    },
    mounted() {
        this.id = this.orderId
        this.onLoad()
    },
    methods: {
        onLoad(page, params = {}) {
            this.loading = true;
            orderInitialRecordList(this.id).then(res => {
                this.data = res.data.data
                this.loading = false;
            }).catch(err => {
                this.loading = false;
            })
        },
        error(err) {
            this.$message.success('请填写完整信息');
        }
    }
}

</script>
<style>
.kinship-wrapper .avue-crud__menu {
    display: none !important;
}

</style>
